// extracted by mini-css-extract-plugin
module.exports = {"phoneIcon":"phoneicon_phoneIcon__Z8ubQ","fadein":"phoneicon_fadein__lXlWM","loading":"phoneicon_loading__WngaV"};